import axios from './config';

export function getCalendar(clubId, languageId) {
  return axios.get(`/${clubId}/${languageId}`);
}
